import { useTranslation } from 'react-i18next';
import StatusFilter from '@/components/filters/StatusFilter/StatusFilter';

export interface IsraeliIdChangeFilterProps {
  /** Supporteds with an open request. */
  count: number;
  isSelected: boolean;
  onToggle: () => void;
}

/**
 * «תיקון מספר זהות» among a supporteds board's filter chips (HAT-1428): the supporteds with an open
 * ID correction request, filtered like any other chip - instead of a line that narrows the board on
 * its own (Chaya, 20.10). Offered only while there are some, like a classification nobody holds.
 *
 * A plain chip, like the classification chips beside it. Its label already says what it filters,
 * so it needs neither the menu's ID-card icon - that one is there because «נתמכים» does not say
 * what is counted - nor a status dot: the requests it finds can be waiting, rejected or corrected,
 * and one colour said the wrong thing about the others (Chaya, 20.10). Their states are the dots
 * beside the names.
 */
const IsraeliIdChangeFilter = ({ count, isSelected, onToggle }: IsraeliIdChangeFilterProps) => {
  const { t } = useTranslation();

  if (count === 0 && !isSelected) return null;

  return (
    <StatusFilter
      title={t('israeliIdChangeRequest.filter')}
      count={count}
      isSelected={isSelected}
      onClick={onToggle}
    />
  );
};

export default IsraeliIdChangeFilter;
